/* eslint-disable */
import * as Types from '../../../../types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from 'graphql-tag';
export type OfferTagsFragment = { __typename: 'Offer', id: string, status: Types.OfferStatus };

export const OfferTagsFragmentDoc = gql`
    fragment OfferTags on Offer {
  id
  status
}
    ` as unknown as DocumentNode<OfferTagsFragment, unknown>;